import type { MachineContext } from 'typings/app/machineContext'
import { matchTripChatCartItem, type TripChatCartSelection } from './tripChatCartSelectionUtils'

export type TripPlannerCartItemsData = MachineContext.CartItems

const MISSING_CART_STATUSES: ReadonlySet<number> = new Set([403, 404])

function hasStatus(error: unknown, statuses: ReadonlySet<number>): boolean {
  if (!error || typeof error !== 'object') return false
  return 'status' in error && typeof error.status === 'number' && statuses.has(error.status)
}

export function isMissingTripPlannerCartError(error: unknown): boolean {
  return hasStatus(error, MISSING_CART_STATUSES)
}

export function mapTripPlannerCartItemsToMap(
  cartData: TripPlannerCartItemsData | undefined,
  multiCartId: string | undefined,
): Map<string, App.MultiCartItem> {
  if (!cartData || !multiCartId) return new Map<string, App.MultiCartItem>()
  const cartItems = cartData[multiCartId]
  if (!cartItems) return new Map<string, App.MultiCartItem>()
  return new Map(
    Object.values(cartItems)
      .filter(item => item.state !== 'deleted')
      .map(item => [item.id, item]),
  )
}

/** The linked row, only while it still books what the itinerary shows. */
export function getTripPlannerCandidateCartItem(
  cartItemsMap: Map<string, App.MultiCartItem>,
  item: TripChatCartSelection,
): App.MultiCartItem | undefined {
  const match = matchTripChatCartItem(cartItemsMap, item)
  return match.status === 'linked' ? match.cartItem : undefined
}
